<template>
  <section class="evento-lux">
    <!-- FLORES EN LOS BORDES (ESTILO EDITORIAL) -->
    <img src="@/assets/ssss.png" class="flor-borde flor-izq" alt="" aria-hidden="true" />
    <img src="@/assets/ssss.png" class="flor-borde flor-der" alt="" aria-hidden="true" />

    <!-- ===== TARJETA 2: RECEPCIÓN ===== -->
    <article ref="card2" class="card anim-tarjeta" aria-label="Recepción">
      <img class="icono2 anim-item" src="@/assets/recep2.png" alt="" />
      <h3 class="titulo-script anim-item">Celebración</h3>
      <p class="hora anim-item">6:00 PM</p>
      
      <p class="lugar anim-item">AG OUTDOOR VENUE</p>

      <!-- FOTO CIRCULAR DEL LUGAR -->
      <div class="foto-lugar-wrapper anim-item">
        <img src="@/assets/unnamed (3).webp" class="foto-lugar" alt="Lugar del evento" />
      </div>

      <p class="direccion anim-item">
        17439 Self Rd / Tomball, Texas.
      </p>

      <a
        class="btn-rosa anim-item"
        href="https://maps.app.goo.gl/Lsr5SPLQN4RPig53A"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>
<br><br>

    <!-- ESCENA FINAL -->
   
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card2 = ref(null)
    let observer = null

    onMounted(() => {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible')
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.25 }
      )

      if (card2.value) {
        observer.observe(card2.value)
      }
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
    })

    return { card2 }
  }
}
</script>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  position: relative;
  min-height: 100%;
  padding: 40px 18px 4px;
  background: radial-gradient(
    circle at 50% 50%,
    #2c2b2c 0%,
    #262525 50%,
    #181717 100%
  );  
   display: grid;
  gap: 22px;
  place-items: center;
  overflow: hidden;
}

/* ==================== FLORES EN BORDES ==================== */
.flor-borde {
  position: absolute;
  width: min(55vw, 190px);
  pointer-events: none;
  z-index: 1;
  opacity: 0.9;
  filter: drop-shadow(0 6px 14px rgba(0,0,0,0.08));
}

.flor-izq {
  top: 5px;
  left: -40px;
  transform: rotate(-25deg);
}

.flor-der {
  bottom: 20px;
  right: -40px;
  transform: rotate(140deg);
}

/* ==================== TARJETA ==================== */
.card{
  position: relative;
  z-index: 2;
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 24px;
  padding: 28px 20px 32px;
  text-align: center;
  background: transparent;}

/* Iconos */
.icono{
  width: 52px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}
.icono2{
  width: 162px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .99;
}

/* Tipografías */
.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 59px;
  color:#e6b1c4;
  letter-spacing: .4px;
  margin: 4px 0 8px;
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #ffff;;
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #ffff;
  font-weight: 500;
  margin: 0 0 14px;
  letter-spacing: .14em;
}

/* FOTO CIRCULAR DEL LUGAR */
.foto-lugar-wrapper {
  width: 190px;
  height: 190px;
  margin: 0 auto 16px;
  border-radius: 50%;
  overflow: hidden;
  padding: 3px;
  background: linear-gradient(135deg, #f5c9e6, #ffffff, #f5c9e6);
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.foto-lugar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color:ffff;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 20px;
  max-width: 90%;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;
  background: #e6b1c4;
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 18px;
  line-height: 1;
  box-shadow: 0 8px 16px rgba(0,0,0,.12), inset 0 1px 0 rgba(255,255,255,.7);
  transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
  border: 1px solid rgba(0,0,0,.06);
  z-index: 1;
  overflow: hidden;
}
.btn-rosa:hover{
  transform: translateY(-2px);
  box-shadow: 0 12px 20px rgba(0,0,0,.16), inset 0 1px 0 rgba(255,255,255,.8);
  filter: brightness(1.03);
}

.btn-rosa .sheen{
  position: absolute; top: -30%; left: -100%;
  width: 60%; height: 160%; transform: rotate(20deg);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.75) 50%, rgba(255,255,255,0) 100%);
  pointer-events: none; mix-blend-mode: screen;
}

/* Animation sheen al aparecer */
.card.is-visible .btn-rosa .sheen {
  animation: brilloBoton 1.2s ease-out 1.2s forwards;
}

@keyframes brilloBoton {
  0% { left: -100%; opacity: 0; }
  50% { opacity: 1; }
  100% { left: 200%; opacity: 0; }
}

/* ==================== ANIMACIONES EDITORIAL (ACCELERATED CSS) ==================== */
.anim-tarjeta {
  opacity: 0;
  transform: translate3d(0, 45px, 0) scale(0.97);
  will-change: transform, opacity;
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.anim-item {
  opacity: 0;
  transform: translate3d(0, 20px, 0);
  will-change: transform, opacity;
  transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Escalonado Editorial al Revelar */
.card.is-visible {
  opacity: 1;
  transform: translate3d(0, 0, 0) scale(1);
}

.card.is-visible .anim-item:nth-child(1) { transition-delay: 0.15s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(2) { transition-delay: 0.25s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(3) { transition-delay: 0.35s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(4) { transition-delay: 0.45s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(5) { transition-delay: 0.55s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(6) { transition-delay: 0.65s; opacity: 1; transform: translate3d(0, 0, 0); }
.card.is-visible .anim-item:nth-child(7) { transition-delay: 0.75s; opacity: 1; transform: translate3d(0, 0, 0); }

/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: -30px;
  overflow: visible;
  z-index: 1;
}

.lux-degradado{
  width: 100%;
  height: 180px;
  background: linear-gradient(
    to top,
    #f6d5e5 0%,
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

.lux-flores{
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 38px; }
  .hora{ font-size: 20px; }
  .lugar{ font-size: 18px; }
  .flor-izq { left: -100px; width: 180px; }
  .flor-der { right: -100px; width: 180px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  .anim-tarjeta, .anim-item {
    transition: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
</style>